import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/modules/query-keys';
import { getNewOpenMarketsCount } from '@/modules/score-api';
import { useLastVisitedMarketsAt } from '@/shared/utils/useLastVisitedMarketsAt';
import { useProfile } from '@/routes/Providers/ProfileProvider';

export function useNewOpenMarketsCount(): number {
  const since = useLastVisitedMarketsAt();
  const issuerId = useProfile().profile?.id;
  const { data } = useQuery({
    queryKey: queryKeys.marketSignalsNewCount(since, issuerId),
    queryFn: () => getNewOpenMarketsCount(since, issuerId),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
  return data ?? 0;
}
